import { nanoid } from 'nanoid'
import { type ActionItem } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { type SurveyRow } from 'entities/Surveys/model/SurveyRow'
import { DetailsSurveyModal } from './ui/DetailsSurveyModal'

export const detailsSurvey = (survey: SurveyRow): ActionItem => {
  return {
    text: 'Details',
    icon: 'eye',
    onAction: () =>
      modalStore.addModal({
        id: nanoid(),
        width: 540,
        position: 'right',
        type: ModalTypeList.DEFAULT,
        ModalContentProps: { survey },
        ModalContent: DetailsSurveyModal,
        title: 'Details',
        pureContent: true,
        fullHeight: true,
      }),
  }
}
